<script>
import service from '@/request/base'
import moment from 'moment'
const notphoto = require('@/assets/noimage.jpg')
const logo = require('@/assets/logo.png')
export default {
  name: 'DatabankNormcaseWindow',
  components: {},
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    praised: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {},
  created: function () {},
  watch: {},
  methods: {
    handleClickImage (event) {
      event.stopPropagation()
      this.$emit('click-image', this.data)
    },
    handleClickTitle (event) {
      event.stopPropagation()
      this.$emit('click-title', this.data)
    },
    handleClickOperator (event) {
      event.stopPropagation()
      this.$emit('click-operator', this.data)
    },
    handleClickEdit (event) {
      event.stopPropagation()
      this.$emit('click-edit', this.data)
    },
    handleClickPraise (event) {
      event.stopPropagation()
      this.$emit('click-praise', this.data)
    }
  },
  filters: {
    imageFilter (value) {
      if (!value) {
        return notphoto
      }
      return service.url(value)
    },
    headerImageFilter (value) {
      if (!value) {
        return logo
      }
      return service.url(value)
    },
    dateFilter (time) {
      if (!time) {
        return ''
      }
      return moment(time).format('YYYY-MM-DD hh:mm')
    },
    publicTypeFilter (value) {
      let name = '公开'
      switch (value) {
        case 0:
          name = '私有'
          break
        case 1:
          name = '公开'
          break
        case 2:
          name = '医院'
          break
        case 3:
          name = '科室'
          break
      }
      return name
    }
  }
}
</script>

<template>
  <div class="normcase-window clear">
    <div class="window-left">
      <a href="javascript:void(0)" @click="handleClickImage($event)">
        <div class="image">
          <div class="image-wrap">
            <img :src="data.ncpImageOne || data.ncpImageTwo || data.ncpImageThree | imageFilter">
          </div>
        </div>
      </a>
    </div>
    <div class="window-right">
      <div class="window-header clear">
        <div class="pull-right">
          <span>{{data.publicType | publicTypeFilter}}</span>
        </div>
        <a href="javascript:void(0)" class="title" @click="handleClickTitle($event)">{{data.title}}</a>
      </div>
      <div class="window-content">
        <div class="nc-info">
          <div class="info-item clear">
            <span class="lable">诊断</span>
            <span class="text">{{data.standardDiseaseNames || data.diagnoseNames || '无'}}</span>
          </div>
          <div class="info-item clear">
            <span class="lable">术式</span>
            <span class="text">{{data.operatingNames || '无'}}</span>
          </div>
        </div>
      </div>
      <div class="window-footer clear">
        <a href="javascript:void(0)" class="author" @click="handleClickOperator($event)">
          <img :src="data.operatorImage | headerImageFilter">
          <span>{{data.operatorName || '未知'}}</span>
          <span v-if="data.orgName">  ·  {{data.orgName}}</span>
          <span v-if="data.hname">[{{data.hname}}]</span>
        </a>
        <div class="footer-icons">
          <div class="footer-icon" v-if="$store.getters.user && $store.getters.user.id && $store.getters.user.id === data.createId">
            <a href="javascript:void(0)" title="修改" @click="handleClickEdit($event)"><i class="fas fa-edit"></i></a>
          </div>
          <!-- <div class="footer-icon">
            <a href="javascript:void(0)" title="分享"><i class="fas fa-share-alt"></i></a>
          </div> -->
          <div class="footer-icon none-right" :class="{done: praised}">
            <a href="javascript:void(0)" title="点赞" @click="handleClickPraise($event)"><i class="fas fa-thumbs-up"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.normcase-window,
.window-header,
.window-footer,
.window-content {
  position: relative;
  width: 100%;
}
.image,
.window-footer,
.normcase-window {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
.normcase-window {
  padding: 10px;
}
.normcase-window a {
  color: #aaa;
  font-style: normal;
  font-weight: 200;
}
.normcase-window a:hover {
  color: #218fcf;
}
.window-left {
  width: 195px;
  height: 148px;
  position: absolute;
  z-index: 1;
  overflow: hidden;
}
.window-right {
  padding-left: 205px;
  position: relative;
}
.window-header {
  text-align: left;
  padding-right: 60px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
.window-content {
  margin: 10px 0;
}
.window-footer {
  line-height: 24px;
  font-size: 14px;
}
.image {
  width: 100%;
  height: 100%;
  font-size: 0;
  background-color: #fff;
  padding: 2px;
}
.image-wrap {
  position: relative;
  width: 100%;
  height: 100%;
}
.image img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  display: block;
  margin: auto;
  padding: auto;
}
.window-header .pull-right {
  position: absolute;
  top: 0;
  right: 0;
  height: 24px;
  line-height: 24px;
  padding: 0 10px;
  color: #aaa;
}
.window-header .title {
  height: 24px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
  display: block;
  font-size: 18px;
  color: #333;
  -webkit-transition: all 0.1s ease-in;
  transition: all 0.1s ease-in;
  -moz-transition: all 0.1s ease-in;
  -ms-transition: all 0.1s ease-in;
  -o-transition: all 0.1s ease-in;
}
.nc-info {
  width: 100%;
  height: 80px;
}
.info-item {
  width: 100%;
  margin-bottom: 5px;
  line-height: 18px;
}
.info-item .lable {
  width: 40px;
  text-align: left;
  float: left;
  color: #909399;
  padding: 0 8px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.info-item .text {
  display: block;
}
.info-item span.text {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2; /** 显示的行数 **/
  overflow: hidden;  /** 隐藏超出的内容 **/
}
.window-footer .author {
  /*width: 208px;*/
  width: 100%;
  margin-right: 36px;
  line-height: 24px;
  display: block;
  float: left;
}
.window-footer .author img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  margin: 2px 6px 0 2px;
  float: left;
}
.window-footer .footer-icons {
  height: 24px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  display: block;
  text-align: right;
  float: right;
}
.window-footer .footer-icon {
  display: inline-block;
  border-right: 1px solid #E3E3E3;
  padding: 0 10px;
  height: 24px;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.window-footer .footer-icon.none-right {
  border-right: 0px solid #E3E3E3;
}
.window-footer .footer-icon.done a {
  color: #409EFF;
}
</style>
